import {
    App, Typography, Row, Col, Tag, Button, Layout,
} from 'antd';
import {
  BorderlessTableOutlined, CarOutlined, SettingOutlined, 
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import {showApiError} from "../../utility/error/error-handler";
import { getSessionData, storeSessionData } from "../../utility/global-util";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";
import PanelFrame from '../../components/panels/PanelFrame';
import SliderPanel from '../../components/panels/SliderPanel';
import { getQuotes } from '../../api/quotes';
import { iconLocations } from "../../components/image/IconLocations";
import { getQuotationPortalLink } from "../../../src/api/security";

const { Text } = Typography;

const QuotesPanel = ({driverQuotes, driver, vehicle, permissions, refreshPage, setRefreshPage, loadingProgress, setLoadingProgress}) => {

    const { t } = useTranslation();
    const { notification } = App.useApp();
    const [ quotes, setQuotes] = useState(driverQuotes);
    const { isOnline } = useOnlineStatus();
    // const [ loadingProgress, setLoadingProgress ] = useState(0);  //start 0 - button shows loading if less than 100
    const [ refreshQuotesPanel, setRefreshQuotesPanel] = useState(false);
    const [ refreshQuotes, setRefreshQuotes] = useState(false);
    const [ quotationPortalLink, setQuotationPortalLink ] = useState(null);
    

    const userCustomer = getSessionData('selectedCustomer');
    let userCustomerAccount = '';
    let userCustomerEntity = '';
    if (userCustomer) {
        userCustomerAccount = userCustomer.code ? userCustomer.code : '';
        userCustomerEntity = userCustomer.entityId ? userCustomer.entityId : '';
    } 

    useEffect(() => {
      if (isOnline)
      {
        if (userCustomerEntity && userCustomerAccount) {
          getQuotes(userCustomerEntity, 'C', userCustomerAccount, setLoadingProgress)
              .then(res => {
                if (res && res?.length > 0) {
                  setRefreshQuotes(true);
                }
                else {
                  setRefreshQuotes(false);
                }
                setQuotes(res);
                storeSessionData('driverQuotes', null);
                storeSessionData('driverQuotes', res);
              },)
              .catch(err => {
                  // Show error if online otherwise show dash if offline (not been on this vehicle or cache not working)
                  showApiError(t('title.quotes'), err, notification);
              });
        }

        getQuotationPortalLink().then(res => {
          setQuotationPortalLink(res);
          },)
          .catch(err => {
            // Show error if online otherwise show dash if offline (not been on this vehicle or cache not working)
            showApiError(t('title.quotes'), err, notification);
        });
        setRefreshPage(false);

        } else {
        // OFFLINE
        setLoadingProgress(100);
        }
        setRefreshQuotesPanel(false);
        
    }, [t, notification, userCustomerEntity, userCustomerAccount, setLoadingProgress, isOnline, refreshQuotesPanel, setRefreshQuotesPanel, refreshPage, setRefreshPage]);

    function getTitle()
    {
        return t('title.quotes');
    }

    function getTagColour(status)
    {
        if (status === "1") {
          return "lime"
        }
        if (status === "2") {
          return "purple"
        }
        if (status === "3") {
          return "red"
        }
        if (status === "4") {
          return "volcano"
        }
    }

    // const IconDisplay = ({source, value}) => {
    //   return (
    //     <table cellSpacing={0} cellPadding={0}>
    //       <tbody>
    //         <tr> 
    //           <td> 
    //             <img src={source} style={{ marginRight: '5px', display: "inline-flex", height:"1.25em" }} alt="" />
    //           </td>
    //           <td>
    //             <Text>{value}</Text>
    //           </td>
    //         </tr>
    //       </tbody>
    //     </table>
    //   );
    // }

    const GoogleIconDisplay = ({source, value}) => {
      return (
        <Row align="middle">
          <img src={source} style={{display: "inline-flex", height:"1.25em"}} alt="" /><Text style={{ marginLeft: '5px' }}>{value}</Text>
        </Row>
      );
    }

    const QuoteCard = ({quote}) => {
      const modelStyle = quote?.restVehicleTechnicalDetails?.style;
      const modelFuel = quote?.restVehicleTechnicalDetails?.fuel;
      const modelTransmission = quote?.restVehicleTechnicalDetails?.transmission;
      const modelEmissions = quote?.restVehicleTechnicalDetails?.emissions;
      const co2_emission = quote && quote?.co2Emissions ? quote?.co2Emissions : modelEmissions.co2Emissions;
      const charging_icon = co2_emission === 0 ? iconLocations.EV_STATION : iconLocations.FUEL_PUMP;
      const periodHireAndDistance = quote?.contractPeriod + ' / ' + quote?.contractDistance; 

      return (
        quote
        ?
        <div>
          {/* Quotations details - part1*/}
          <Row style={{width:"100%"}} align="middle">
            <Col xs={15} sm={12} md={7} lg={5} xl={4}>
                <BorderlessTableOutlined /><Text style={{ marginLeft: '5px' }}>{quote.quoteRef}</Text>
            </Col>
            <Col xs={9} sm={12} md={0} lg={0} xl={0}>
                <Tag style={{ float:"right", marginBottom: "4px" }} key={quote.status?.key} color={getTagColour(quote.status.key)}>{quote.status.description}</Tag>
            </Col>                     
            <Col xs={24} sm={24} md={11} lg={16} xl={18}>
                <table cellSpacing={0} cellPadding={0}>
                  <tbody>
                    <tr> 
                      <td> 
                        <CarOutlined style={{ marginRight: '5px' }}/>
                      </td>
                      <td>
                        <Text>{quote.modelVariant}</Text>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </Col>     
            <Col xs={0} sm={0} md={6} lg={3} xl={2}>
                <Tag style={{ float:"right", marginBottom: "4px" }} key={quote.status?.key} color={getTagColour(quote.status.key)}>{quote.status.description}</Tag>
            </Col>                     
          </Row>

          {/* Model technical details - part1 */}
          <Row style={{marginTop: "5px", paddingLeft: "5px", paddingTop: "5px",  backgroundColor: "var(--dp-panel-section-colour)"}}>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <CarOutlined /> <Text style={{ marginLeft: '5px' }}>{modelStyle.bodyType}</Text>
            </Col>     
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
               <GoogleIconDisplay source={iconLocations.CAR_SEAT} value={modelStyle.numberOfSeats+ ' ' + t('field.seats')} ></GoogleIconDisplay>
            </Col>     
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <GoogleIconDisplay source={iconLocations.FUEL_PUMP} value={modelFuel.fuelType} ></GoogleIconDisplay>
            </Col>   
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <GoogleIconDisplay source={iconLocations.PUBLIC_ICON} value={modelEmissions.emissionStandard} ></GoogleIconDisplay>
            </Col>             
          </Row>

          {/* Model technical details - part2 */}
          <Row style={{marginBottom: "5px", paddingLeft: "5px", paddingBottom: "5px", backgroundColor: "var(--dp-panel-section-colour)"}}>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <SettingOutlined/> <Text style={{ marginLeft: '5px' }}>{modelTransmission.transmissionType}</Text>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <GoogleIconDisplay source={iconLocations.CAR_DOOR} value={modelStyle.numberOfDoors + ' ' + t('field.doors')} ></GoogleIconDisplay>
            </Col>     
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <GoogleIconDisplay source={charging_icon} value={quote?.mpgRange} ></GoogleIconDisplay>
            </Col> 
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <GoogleIconDisplay source={iconLocations.CAR_EMISSION} value={co2_emission + ' ' + t('field.co2_uom')} ></GoogleIconDisplay>
            </Col>               
          </Row>

          {/* Quotations details - part2*/}
          <Row> 
            <Col xs={13} sm={10} md={7} lg={5} xl={4} className='dp-field-label'>
              { t('field.period_distance') } 
            </Col>            
            <Col xs={11} sm={14} md={17} lg={7} xl={8}>
              <Text>{periodHireAndDistance}</Text>
            </Col> 
            <Col xs={13} sm={10} md={7} lg={5} xl={4} className='dp-field-label'>
              { t('field.last_revision') } 
            </Col>            
            <Col xs={11} sm={14} md={17} lg={7} xl={8}>
              <Text>{quote?.revisionDate}</Text>
            </Col> 
          </Row>
          
          <Row> 
            <Col xs={13} sm={10} md={7} lg={5} xl={4} className='dp-field-label'>
              { t('field.taxable_list_price') } 
            </Col>            
            <Col xs={11} sm={14} md={17} lg={7} xl={8}>
              <Text>{quote?.taxableListPrice}</Text>
            </Col>
            <Col xs={13} sm={10} md={7} lg={5} xl={4} className='dp-field-label'>
              { t('field.expiry') }
            </Col> 
            <Col xs={11} sm={14} md={17} lg={7} xl={8}>
              <Text>{quote?.quoteExpiryDateStr}</Text>
            </Col> 
          </Row>
          <Row> 
            <Col xs={13} sm={10} md={7} lg={5} xl={4} className='dp-field-label'>
              { t('field.rental') } 
            </Col> 
            <Col xs={11} sm={14} md={17} lg={7} xl={8}>
              <Text>{quote?.rental}</Text>
            </Col>            
          </Row>          
        </div>
        :
        <></>
      )
    }

    function getQuotePanels(quotes)
    {
      return quotes.map(quote => { return(
        <div key={quote.id}>
          {/* <Row><Text className='dp-panel-frame-title' style={{'color': 'var(--dp-panel-text-colour)'}}>{quote.quoteRef}</Text></Row> */}
          <QuoteCard quote={quote}/>
        </div>)
      })
    }

    const Buttons = () => {
      return (
        isOnline
        ?
        <Button type="primary" 
                target="_blank"
                href={quotationPortalLink}
                loading={loadingProgress !== 100} 
                onClick={(e) => createQuoteButton(e)}
        >
          {t('action.new_quote')}
        </Button>
        :
        <></>
      );
    }    

    const createQuoteButton = (e) => {
      // Moved the getApexurl to here as there is a time limit on the token when authenticating on Apex's side
      // in the event the driver stays a while before accessing the quote app, there is the likelihood quote portal authentication may fail      
      getQuotationPortalLink().then(res => {
        setQuotationPortalLink(res);
        },)
        .catch(err => {
          // Show error if online otherwise show dash if offline (not been on this vehicle or cache not working)
          showApiError(t('title.quotes'), err, notification);
      });      
    };    

    return (
      <PanelFrame title={getTitle()}
                  refreshable={refreshQuotes && isOnline}
                  onRefresh={setRefreshQuotesPanel}
      >
        <Layout>
          <Layout.Content>
            <SliderPanel children={getQuotePanels(quotes)}/>
          </Layout.Content>
         
         <Layout.Footer>
          {
            permissions.includes("QUOTES")
            ?
            <Buttons />
            :
            <></>
          }
         </Layout.Footer>         
        </Layout>
      </PanelFrame> 
    )
}

export default QuotesPanel;
